// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/nav-definitions.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/nav-definitions/nav-definitions.js';

mount([g0]);
